<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>

        <v-app>
            <v-navigation-drawer clipped app fixed v-model="drawer">

                <v-flex ma-3>

                    <span><strong>{{ $t('search_animal_type_label') }}</strong></span>

                    <v-radio-group v-model="selectedAnimalType" v-on:change="onAnimalTypeChanged">
                        <v-radio
                                v-for="item in animalType"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value"
                        ></v-radio>
                    </v-radio-group>

                    <v-select
                            :items="sizes"
                            :label="$t('search_size_label')"
                            v-model="selectedSize"
                            multiple
                            v-on:change="onSizeChanged">
                    </v-select>

                    <v-select
                            :items="age"
                            :label="$t('search_age_label')"
                            v-model="selectedAge"
                            v-on:change="onAgeChanged">
                    </v-select>

                    <v-select
                            :items="gender"
                            :label="$t('search_gender_label')"
                            multiple
                            v-model="selectedGender"
                            v-on:change="onGenderChanged">
                    </v-select>

                    <v-select
                            chips
                            :items="residenceCountries"
                            :label="$t('search_residence_country_label')"
                            item-text="display_name"
                            item-value="code"
                            v-model="selectedResidenceCountry"
                            multiple
                            v-on:change="onResidenceCountryChanged">
                    </v-select>

                    <v-select
                            :items="animalStatuses"
                            :label="$t('search_animal_status')"
                            v-model="selectedAnimalStatus"
                            v-on:change="onAnimalStatusChanged">
                    </v-select>
                    <v-btn large block class="mt-4 d-flex d-sm-none" color="primary" @click="closeDrawer()">{{ $t('search_show_results') }}</v-btn>
                </v-flex>

            </v-navigation-drawer>

            <v-app-bar app fixed clipped-left dark color="primary">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer">
                    <v-icon size="20px">fa-filter</v-icon>
                </v-app-bar-nav-icon>
                <v-toolbar-title class="headline text-uppercase">
                    <span class="font-weight-light">{{ this.$root.configuration.name }}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-menu
                        v-if="this.$root.configuration.supported_languages.length > 1"
                        left
                        bottom
                >
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" class="hidden-sm-and-up">
                            <country-flag :country="languages[$i18n.locale].flag" size="normal"/>
                        </v-btn>

                        <v-btn text
                               large
                               class="pl-2 pr-2 hidden-xs-only"
                               v-on="on"><country-flag :country="languages[$i18n.locale].flag" size="normal" class="mr-0"/> {{ languages[$i18n.locale].display }}
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item
                                v-for="n in this.$root.configuration.supported_languages"
                                :key="n"
                                @click="onLanguageChange(n)">
                            <v-list-item-title>{{ languages[n].display }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-app-bar>

            <v-content>
                <div>
                    <v-container fluid ma-0 pa-0 fill-height class="pt-3 pl-3 pr-3">
                            <v-row no-gutters>
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4" md="3" xs="12">
                                    <v-select
                                            :items="sortOrder"
                                            :label="$t('search_sort_order_label')"
                                            v-model="selectedSortOrder"
                                            v-on:change="onSortOrderChanged">
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(data.item.text) }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            {{ $t(data.item.text) }}
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                    </v-container>
                    <div v-if="selectedSortOrder == 'alphabetical'" class="text-center">
                        <v-chip :outlined="selectedAlphabetLetter != null"
                                color="primary"
                                class="ma-1"
                                :text-color="selectedAlphabetLetter == null ? 'white' : 'primary'"
                                @click="onAlphabetLetterChanged(null)">{{ $t('search_animal_alphabet_letter_all') }}</v-chip>
                        <v-chip v-for="letter in alphabet"
                                :outlined="letter != selectedAlphabetLetter"
                                class="ma-1"
                                color="primary"
                                :text-color="letter == selectedAlphabetLetter ? 'white' : 'primary'"
                                @click="onAlphabetLetterChanged(letter)">{{ letter }}</v-chip>
                    </div>
                    <v-container grid-list-xl>
                        <v-layout row wrap>
                            <v-flex v-for="listing in animals"
                                    :listing="listing"
                                    :key="listing.id" md4 sm6 xs12>
                                <listing-summary
                                        :listing="listing"
                                        :key="listing.id">
                                </listing-summary>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <infinite-loading spinner="waveDots" :identifier="infiniteId" @infinite="load">
                    <span slot="no-more"></span>
                </infinite-loading>
                <v-btn
                        v-scroll="onScroll"
                        v-show="fab"
                        fab
                        dark
                        fixed
                        bottom
                        right
                        color="primary"
                        @click="toTop"
                >
                    <v-icon>keyboard_arrow_up</v-icon>
                </v-btn>
            </v-content>
        </v-app>
    </div>
</template>
<script>
    import ListingSummary from './ListingSummary.vue';
    import axios from 'axios';
    import InfiniteLoading from 'vue-infinite-loading';
    import saveState from 'vue-save-state';
    import CountryFlag from 'vue-country-flag'

    export default {
        data () {
            return {
                languages: {
                    'en': {
                        'display': 'English',
                        'flag': 'gb'
                    },
                    'nl': {
                        'display': 'Nederlands',
                        'flag': 'nl'
                    },
                    'es': {
                        'display': 'Español',
                        'flag': 'es'
                    }
                },
                animals: [],
                call: null,
                infiniteId: +new Date(),
                nextUrl: 'api/animal',
                drawer: this.$vuetify.breakpoint.smAndUp,
                selectedGender: null,
                selectedAge: null,
                selectedAnimalType: null,
                selectedSize: null,
                selectedResidenceCountry: null,
                selectedSortOrder: 'default',
                selectedAnimalStatus: null,
                selectedAlphabetLetter: null,
                alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
                fab: false,
                residenceCountries: [],
            }
        },
        computed: {
            animalType() {
                return [
                    {
                        text: this.$t("search_animal_type_value_dog"),
                        value: 'dog'
                    },
                    {
                        text: this.$t("search_animal_type_value_cat"),
                        value: 'cat'
                    }
                ];
            },
            sizes() {
                return [
                    {
                        text: this.$t("search_size_value_small"),
                        value: 'small'
                    },
                    {
                        text: this.$t("search_size_value_medium"),
                        value: 'medium'
                    },
                    {
                        text: this.$t("search_size_value_large"),
                        value: 'large'
                    }
                ];
            },
            age() {
                return [
                    {
                        text: this.$t("search_age_value_pup"),
                        value: 'pup'
                    },
                    {
                        text: this.$t("search_age_value_adult"),
                        value: 'adult'
                    },
                    {
                        text: this.$t("search_age_value_senior"),
                        value: 'senior'
                    },
                    {
                        text: this.$t("search_age_value_all"),
                        value: 'all'
                    }
                ];
            },
            gender() {
                return [
                    {
                        text: this.$t("search_gender_value_male"),
                        value: 'male'
                    },
                    {
                        text: this.$t("search_gender_value_female"),
                        value: 'female'
                    }
                ];
            },
            animalStatuses() {
                return [
                    {
                        text: this.$t("search_animal_status_all"),
                        value: null
                    },
                    {
                        text: this.$t("search_animal_status_available_for_adoption"),
                        value: 'available_for_adoption'
                    },
                    {
                        text: this.$t("search_animal_status_reserved"),
                        value: 'reserved'
                    },
                    {
                        text: this.$t("search_animal_status_adopted"),
                        value: 'adopted'
                    }
                ];
            },
            sortOrder() {
                return [
                    {
                        text: this.$t("search_sort_order_value_default"),
                        value: 'default'
                    },
                    {
                        text: this.$t("search_sort_order_value_newest_first"),
                        value: 'newest_first'
                    },
                    {
                        text: this.$t("search_sort_order_value_oldest_first"),
                        value: 'oldest_first'
                    },
                    {
                        text: this.$t("search_sort_order_value_alphabetical"),
                        value: 'alphabetical'
                    }
                ];
            }
        },
        mounted() {
            this.$title = this.$t("home_title");

            this.animals = this.$memStore.get('animals');
            this.nextUrl = this.$memStore.get('nextUrl');

            if(this.animals == null) {
                this.refreshAnimals();
            }

            this.reload(false);
        },
        mixins: [saveState],
        methods: {
            closeDrawer() {
                this.drawer = false;
            },
            onLanguageChange(language) {
                this.$localStore.set('language', language);

                this.$i18n.locale = language;
                axios.defaults.headers.common['Accept-Language'] = language;
                this.reload(true);
                this.refreshAnimals();
            },
            resolveMinAgeMonths() {
                if (this.selectedAge == 'pup') {
                    return null;
                } else if (this.selectedAge == 'adult') {
                    return 12;
                } else if (this.selectedAge == 'senior') {
                    return 96;
                } else {
                    return null;
                }
            },
            resolveMaxAgeMonths() {
                if (this.selectedAge == 'pup') {
                    return 12;
                } else if (this.selectedAge == 'adult') {
                    return 96;
                } else if (this.selectedAge == 'senior') {
                    return null;
                } else {
                    return null;
                }
            },
            load ($state) {
                if (this.nextUrl == null) {
                    $state.loaded();
                    $state.complete();
                    return;
                }
                if (this.call != null) {
                    this.call.cancel();
                }
                this.call = axios.CancelToken.source();

                axios.get(this.nextUrl, {
                            cancelToken: this.call.token,
                            params: {
                                'type': this.selectedAnimalType,
                                'size': this.selectedSize != null ? this.selectedSize.join() : null,
                                'gender': this.selectedGender != null ? this.selectedGender.join() : null,
                                'min_age_months': this.resolveMinAgeMonths(),
                                'max_age_months': this.resolveMaxAgeMonths(),
                                'animal_residence_country': this.selectedResidenceCountry != null ? this.selectedResidenceCountry.join() : null,
                                'sort_order': this.selectedSortOrder != null ? this.selectedSortOrder : null,
                                'status': this.selectedAnimalStatus != null ? this.selectedAnimalStatus : null,
                                'name_starts_with': this.selectedAlphabetLetter != null ? this.selectedAlphabetLetter : null
                            }
                        })
                        .then(response =>
                {
                    this.animals = this.animals.concat(response.data.data);
                this.nextUrl = response.data.links.next;

                this.$memStore.set('animals', this.animals);
                this.$memStore.set('nextUrl', this.nextUrl);

                if(response.data.data.length) {
                    $state.loaded();
                }
                if (this.nextUrl == null) {
                    $state.complete();
                }
            }
            ).catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled', thrown.message);
                    } else {
                        $state.error();
                    }
                });
            },
            onAnimalTypeChanged() {
                this.refreshAnimals();
            },
            onGenderChanged() {
                this.refreshAnimals();
            },
            onSizeChanged() {
                this.refreshAnimals();
            },
            onAgeChanged() {
                this.refreshAnimals();
            },
            onResidenceCountryChanged() {
                this.refreshAnimals();
            },
            onSortOrderChanged() {
                this.selectedAlphabetLetter = null;
                this.refreshAnimals();
            },
            onAnimalStatusChanged() {
                this.refreshAnimals();
            },
            onAlphabetLetterChanged(letter) {
                this.selectedAlphabetLetter = letter;
                this.refreshAnimals();
            },
            refreshAnimals() {
                this.nextUrl = 'api/animal';
                this.animals = [];

                this.infiniteId += 1;
            },
            reload(clearCache) {
                axios.get("/api/animal/residence_countries", {
                            cache: {
                                maxAge: 60 * 60 * 1000 // 1 hour
                            },
                            clearCacheEntry: clearCache
                        })
                        .then(response => {
                    this.residenceCountries = response.data;
                });
            },
            getSaveStateConfig() {
                return {
                    'cacheKey': 'overview',
                    'saveProperties': ['selectedGender', 'selectedAge', 'selectedAnimalType', 'selectedSize',
                        'selectedResidenceCountry', 'selectedSortOrder', 'selectedAnimalStatus', 'drawer'],
                };
            },
            onScroll (e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset ||   e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop () {
                this.$vuetify.goTo(0)
            }
        },
        components: {
            ListingSummary,
            InfiniteLoading,
            CountryFlag
        }
    }
</script>
<style>
</style>
